<script setup>
import { ref, watch } from 'vue';
import { useIntersectionObserver, useCssVar } from '@vueuse/core';

const isSticky = ref(false);
const headerBarRef = ref(null);

const headerHeight = useCssVar(
    "--header-height",
    ref(document.documentElement),
    {
        initialValue: '0px',
        observe: true,
    }
);

// Beobachte das Element mit VueUse
const createObserver = (headerHeightValue) => {
    return useIntersectionObserver(
        headerBarRef,
        ([entry]) => {
            isSticky.value = entry.boundingClientRect.top < parseFloat(headerHeightValue) && entry.intersectionRatio < 1;
        },
        { threshold: [1.0], rootMargin: `-${headerHeightValue} 0px 0px 0px` }
    );
};

let { stop } = createObserver(headerHeight.value);

watch(headerHeight, (newVal, oldVal) => {
    if (newVal !== oldVal) {
        stop(); // Stop the current observer
        ({ stop } = createObserver(newVal)); // Reinitialize the observer with the updated headerHeight value
    }
});

watch(
    () => headerBarRef.value,
    (newVal, oldVal) => {
        if (!newVal && oldVal) {
            stop();
        }
    }
);
</script>

<template>
    <header ref="headerBarRef" :class="{ 'is-sticky': isSticky }">
        <slot />
    </header>
</template>

<style scoped>
</style>
